import { useEffect, useState } from 'react';
const useElementVisible = (ref) => {
    const [isElementVisible, setIsElementVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIsElementVisible(entry.isIntersecting);
        }, { threshold: 0.1 });
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            observer.observe(ref.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [ref]);
    return isElementVisible;
};
const useIsDocumentVisible = () => {
    const [isDocumentVisible, setIsDocumentVisible] = useState(true);
    useEffect(() => {
        const handleVisibilityChange = () => {
            setIsDocumentVisible(!document.hidden);
        };
        const handleWindowBlur = () => {
            setIsDocumentVisible(false);
        };
        const handleWindowFocus = () => {
            setIsDocumentVisible(true);
        };
        if (document && window) {
            document.addEventListener('visibilitychange', handleVisibilityChange);
            window.addEventListener('blur', handleWindowBlur);
            window.addEventListener('focus', handleWindowFocus);
        }
        return () => {
            if (document && window) {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
                window.removeEventListener('blur', handleWindowBlur);
                window.removeEventListener('focus', handleWindowFocus);
            }
        };
    }, []);
    return isDocumentVisible;
};
export const useInForeground = (ref) => {
    const isElementVisible = useElementVisible(ref);
    const isDocumentVisible = useIsDocumentVisible();
    return isElementVisible && isDocumentVisible;
};
